import { Component } from '@angular/core';
import { plainToInstance } from 'class-transformer';
import { TranslateHelper } from '../../../../helpers/injector.helper';
import { TaskRegistryEntry, TaskType } from '../../../../helpers/task.registry';
import { CellStyle } from '../../../../models/styling/cell.style';
import { TaskHelper } from '../../../../models/tasks/task.helper';
import { ALevelPanel, ALevelTaskSettingsHelper } from '../../a.task.panel';

@Component({
    selector: 'columndescriptionheader-formatting-task-panel',
    templateUrl: './columndescriptionheader.formatting.task.panel.html'
})
export class ColumndescriptionheaderFormattingTaskPanel extends ALevelPanel {

    ColumnIndex: number;

    static GetRegistry(): TaskRegistryEntry {
        const reg = new TaskRegistryEntry();
        reg.ID = 'columndescriptionheaderformattingtask';
        reg.Caption = '@@Beschreibungsspaltenkopf';
        reg.SettingsControl = ColumndescriptionheaderFormattingTaskPanel;
        reg.SettingsHelper = new ColumndescriptionheaderFormattingTaskSettingsHelper();
        reg.TaskType = TaskType.FormatTask;
        return reg;
    }

    OnSettingsSet() {
        if (this.SettingsValue) {
            if (this.SettingsValue.Style) {
                if (!(this.SettingsValue.Style instanceof CellStyle)) {
                    this.SettingsValue.Style = plainToInstance(CellStyle, this.SettingsValue.Style);
                }
            } else {
                this.SettingsValue.Style = new CellStyle();
            }
        }
    }
}

export class ColumndescriptionheaderFormattingTaskSettingsHelper extends ALevelTaskSettingsHelper {
    canExecute(reportObject: any): boolean {
        return TaskHelper.IsTableObject(reportObject);
    }
    getCaption(task: any, dd: any) {
        const caption = super.getCaption(task, dd);
        if (caption) {
            return caption + ' - ' + TranslateHelper.TranslatorInstance.instant('@@Beschreibungsspaltenformatierung');
        }
        return TranslateHelper.TranslatorInstance.instant('@@Beschreibungsspaltenformatierung');
    }
}
